import auth from './auth'
// import language from './language'
import stationStore from './station'
export default {
  // language,
  auth,
  stationStore
}